// Eph console → API eph; resto de deps = QA (qa-*).
export const environment = {
  production: false,
  inactive: false,

  BASE_LA: 'https://eph-kredit-api.creditotal.online',
  BASE_RECHARGE: 'https://qa-recharge-api.creditotal.online',
  BASE_FORNT2: 'https://qa-console.creditotal.online',
  BASE_FORNT: 'https://eph-app.creditotal.online',
  redirectRoute: '/console/create-constacts',
  searchClient: '/console/create-constacts',
  psicometrico: '/console/psicometrico',
  initRoute: '/console/search-client',
  BASE_BDV_API: 'https://qa-api-bdv-payment-button.creditotal.online',

  externalPsicometrico: 'https://www.acredita.com.ve:8860/psicometrico/home_test.php',

  loginRoute: '/login',
  logoutRoute: '/logout',

  socketBase: {
    SOCKET_ENDPOINT: 'https://qa-api-socket.creditotal.online/',
  },

  ClieID: '12',
  CED: '11314836',
  IP_LOCAL: '34.58.231.230',
  REWARDS_FRONT_URL: 'https://qa-app-rewards.creditotal.online',

  ONBOARDING_LA: 'https://qa-api-onboarding.creditotal.online',

  ANALYSIS_REPORT: 'https://analytics-api.creditotal.online',

  BASE_CASH_REGISTER_PAYMENT: 'https://qa-api-payment-pos.creditotal.online',

  TRUSTX: 'https://trustx-dev-api.akeela.co',
};
